class CustomModal extends HTMLElement {
    constructor() {
        super(); // Llama al constructor de HTMLElement
    }

    connectedCallback() {
        this.load();
        this.events();
    }

    load = () => {
        // console.log(this);
    };

    events = () => {
        this.addEventListener("click", (e) => {
            const btnSave = e.target.closest("[name=save]");
            
            if (btnSave) {
                const form = this.querySelector("form[name=form]");

                if (form.reportValidity()) {
                    form?.submit();
                }
            }
        });
    };
}

customElements.define("custom-modal", CustomModal);
